<template>
  <div>
    <div class="col-md-6">
      <label class="form-control-label" for="userSearch">جستجو کاربر</label>
      <vue-select v-model="user" :options="modifiedUsersList" dir="rtl" label="searchProp">
        <template #no-options="{ search, searching, loading }">
          موردی یافت نشد!
        </template>
      </vue-select>
    </div>
    <div>
      <hr class="horizontal dark" />
    </div>
    <!--<ul class="list-group list-group-flush flex-flow-row">-->
    <ul class=" row Col-lg-12 col-md-12 col-sm-12 col-xs-12 px-2">
      <template v-for="item in memberUsers">
        <li class="list-group-item col-lg-4 col-md-4 col-sm-6 col-xs-12 px-2">
          <div class="row align-items-center">
            <div class="col-auto d-flex align-items-center">
              <a href="javascript:;" class="avatar">
                <img class="border-radius-lg" alt="Image placeholder" src="../../assets/img/team-1.png">
              </a>
            </div>
            <div class="col ml-2">
              <h6 class="mb-0">
                {{ item.firstName }} {{ item.lastName }}
              </h6>
              <span v-if="item.isActive != undefined" class="badge badge-sm"
                :class="{ 'badge-success': item.isActive, 'badge-danger': !item.isActive }">{{ item.isActive ? 'فعال'
                : 'غیرفعال' }}</span>
            </div>
            <div class="col-auto">
              <button type="button" @click="$emit('removeUser', item)" class="btn btn-danger btn-xs mb-0">
                حذف
              </button>
            </div>
          </div>
        </li>
      </template>
    </ul>
  </div>
</template>

<script>
export default {
  props: ['usersList', 'memberUsers', 'companyId'],
  data() {
    return {
      user: null,
    }
  },
  watch: {
    user(user) {
      if (user !== {} && user !== null) {
        let index = this.memberUsers.map(user => user.id).indexOf(user.id);

        if (index == -1) {
          this.$emit('addUser', this.user);
        }

        this.user = null;
      }
    },
    companyId(newId, oldId) {
      if (newId !== oldId) {
        this.user = null;
      }
    }
  },
  computed: {
    modifiedUsersList() {
      return this.usersList.map(user => ({ ...user, searchProp: (user.lastName + ' ' + user.firstName + ' - ' + user.postTitle) }));
    }
  }
};
</script>
